import React from 'react'
import styled from 'styled-components'
import { View } from '../../atoms/View'
import { GenericErrorBox } from '../../molecules/GenericErrorBox'

export const acceptedErrors = {
  GENERIC_ERROR: 'GENERIC_ERROR',
  FORGOT_PASSWORD_GENERIC_ERROR: 'FORGOT_PASSWORD_GENERIC_ERROR',
  RATE_LIMIT_ERROR: 'RATE_LIMIT_ERROR',
  UNREGISTERED_EMAIL_ERROR: 'UNREGISTERED_EMAIL_ERROR',
  INACTIVE_ACCOUNT_ERROR: 'INACTIVE_ACCOUNT_ERROR',
  SAME_PASSWORD_ERROR: 'SAME_PASSWORD_ERROR',
  PASSWORD_MISMATCH_ERROR: 'PASSWORD_MISMATCH_ERROR',
}

const errorTexts = {
  [acceptedErrors.GENERIC_ERROR]: {
    showContactUs: true,
    text: 'Não foi possível salvar sua nova senha.',
  },
  [acceptedErrors.RATE_LIMIT_ERROR]: {
    showContactUs: false,
    text: 'Você excedeu o número de tentativas. Por favor, tente novamente mais tarde.',
  },
  [acceptedErrors.INACTIVE_ACCOUNT_ERROR]: {
    showContactUs: true,
    contactUsLink: 'https://ajuda.olx.com.br/s/article/reativar-conta-na-olx',
    text: 'Este e-mail não pode mais ser usado.',
  },
  [acceptedErrors.FORGOT_PASSWORD_GENERIC_ERROR]: {
    showContactUs: false,
    text: 'Não foi possível solicitar a recuperação de senha.',
  },
}

const ErrorMsgWrapper = styled(View)`
  margin-top: var(--spacing-2);
  margin-right: 0;
  margin-bottom: var(--spacing-2);
  margin-left: 0;
`

const ErrorHandler = ({ errorType }) => {
  return (
    <ErrorMsgWrapper>
      <GenericErrorBox {...(errorTexts[errorType] || errorTexts[acceptedErrors.GENERIC_ERROR])} />
    </ErrorMsgWrapper>
  )
}

export default ErrorHandler
